import { GET_ADDRATECARD_FAILED, GET_ADDRATECARD_REQUESTED, GET_ADDRATECARD_SUCCESS, GET_BASE_FUEL_FAILED, GET_BASE_FUEL_REQUESTED, GET_BASE_FUEL_SUCCESS, GET_RATECARD_FAILED, GET_RATECARD_REQUESTED, GET_RATECARD_SUCCESS} from "resources/actionTypes";

const intialState = {
  userRateCard: [],
  loading: false,
  error: null,
};
const intialStateAdd = {
  userAddRateCard: [],
  loading: false,
  error: null,
}
const intialStateBaseFuel = {
  userBaseFuel: [],
  loading: false,
  error: null,
};


export function userRateCard(state = intialState, action) {
  switch (action.type) {
    case GET_RATECARD_REQUESTED:
      return {
        ...state,
        loading: true,
      }
    case GET_RATECARD_SUCCESS:
      return {
        ...state,
        loading: false,
        userRateCard: action.userRateCard,
      }
    case GET_RATECARD_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      }
    default:
      return state;
  }
}

export function userAddRateCard(state = intialStateAdd, action) {
  switch (action.type) {
    case GET_ADDRATECARD_REQUESTED:
      return {
        ...state,
        loading: true,
      }
    case GET_ADDRATECARD_SUCCESS:
      return {
        ...state,
        loading: false,
        userAddRateCard: action.userAddRateCard,
      }
    case GET_ADDRATECARD_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      }
    default:
      return state;
  }
}

export function userBaseFuel(state = intialStateBaseFuel, action) {
  switch (action.type) {
    case GET_BASE_FUEL_REQUESTED:
      return {
        ...state,
        loading: true,
      }
    case GET_BASE_FUEL_SUCCESS:
      return {
        ...state,
        loading: false,
        userBaseFuel: action.userBaseFuel,
      }
    case GET_BASE_FUEL_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      }
    default:
      return state;
  }
}

